import React, { Component } from "react"
import "./Shelf.scss";

import ShelfImg from "./img/Shelf.svg"

class Shelf extends Component {
    render() {
        return (
          <ul>
            <li
                id={"Shelf_"+this.props.id}
                className="Shelf">
                <img src={ShelfImg} aria-label={'Laboratory shelf'}/>
            </li>
          </ul>
        )
    }
}
export default Shelf;
